import axios from "axios";

export const listTemplates = async (params = {}) => {
  const response = await axios.get("print-templates", { params });
  return response.data;
};

export const getActiveTemplate = async (documentType, stageCode = null) => {
  const response = await axios.get("print-templates/active", {
    params: { document_type: documentType, stage_code: stageCode },
  });
  return response.data;
};

export const getTemplateById = async (id) => {
  const response = await axios.get(`print-templates/${id}`);
  return response.data;
};

export const createTemplate = async (data) => {
  const response = await axios.post("print-templates", data);
  return response.data;
};

export const updateTemplate = async (id, data) => {
  const response = await axios.put(`print-templates/${id}`, data);
  return response.data;
};

export const setDefaultTemplate = async (id) => {
  const response = await axios.put(`print-templates/${id}/set-default`);
  return response.data;
};

export const deleteTemplate = async (id) => {
  const response = await axios.delete(`print-templates/${id}`);
  return response.data;
};

export const seedDefaultTemplates = async () => {
  const response = await axios.post("print-templates/seed");
  return response.data;
};
